import script from "./BarrelDimensionInputs.vue?vue&type=script&setup=true&lang=ts"
export * from "./BarrelDimensionInputs.vue?vue&type=script&setup=true&lang=ts"

import "./BarrelDimensionInputs.vue?vue&type=style&index=0&id=1fc22a59&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fc22a59"]])

export default __exports__